<div class="h-full flex flex-col lg:flex-row gap-2 overflow-hidden p-2 lg:pl-0">

    <!-- Conversations -->
    <div class="max-h-64 lg:max-h-none lg:w-80 flex flex-col gap-2 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 overflow-hidden">
        <div class="flex items-center justify-between p-2">
            <h2 class="subheading">Conversations</h2>
            <button *ngIf="isBrokerStaff || !chats.length" type="button" (click)="startNewChat()" class="btn btn-secondary sm:text-xs/5">
                New chat
            </button>
        </div>

        <div *ngIf="isContactPickerOpen" class="px-2 space-y-2">
            <div class="flex items-center justify-between">
                <h3 class="subheading">New chat</h3>
                <button type="button" (click)="isContactPickerOpen = false" class="text-sm-light hover:text-zinc-950 dark:hover:text-white" title="Close">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <app-support-contact-picker typeLabel="Chat With" [stacked]="true"
                (selectContact)="onSelectContact($event)"></app-support-contact-picker>
        </div>

        <div (scroll)="onScrollChats($event)" class="flex-1 min-h-0 overflow-y-auto divide-y divide-zinc-950/10 dark:divide-white/10">
            <a href="javascript:void(0)" *ngFor="let chat of chats; trackBy: trackById" (click)="selectChat(chat)"
                class="flex items-center gap-2 px-3 py-2 hover:bg-gray-950/5 dark:hover:bg-white/10"
                [ngClass]="{ 'bg-gray-950/5 dark:bg-white/10': chat.id === selectedChat?.id }">
                <div class="flex-1 min-w-0">
                    <div class="flex justify-between gap-2">
                        <span class="text-sm font-medium text-main-dark truncate">{{chat.title}}</span>
                        <span class="text-xs text-main-light text-nowrap">{{chat.time}}</span>
                    </div>
                    <div class="flex justify-between gap-2">
                        <span class="text-xs text-main-light truncate">{{chat.lastMessage}}</span>
                        <span *ngIf="chat.unreadCount" class="badge-danger">{{chat.unreadCount}}</span>
                    </div>
                </div>
            </a>
            <p *ngIf="!chats.length && !isLoadingChats" class="p-3 text-sm-light">No conversations yet</p>
        </div>
    </div>

    <!-- Thread -->
    <div class="flex-1 min-h-0 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 overflow-hidden">
        <ng-container *ngIf="selectedChat; else noChatSelected">
            <div class="p-4 border-b border-zinc-950/10 dark:border-white/10">
                <div class="text-sm font-medium text-main-dark">{{selectedChat.title}}</div>
            </div>
            <app-chat-thread [chatId]="selectedChat.id" [currentUser]="currentUser" class="flex-1 min-h-0"></app-chat-thread>
        </ng-container>
        <ng-template #noChatSelected>
            <p class="m-auto text-sm-light">Select a conversation</p>
        </ng-template>
    </div>
</div>
